import { Role, User } from '../../types';
import { ADMIN_GROUP } from '../../constants/roles';

export function isInGroup(user: User, group: string[]) {
  let inGroup = false;

  if (!user) {
    return false;
  }

  for (const role of user.roles) {
    if (group.includes(role)) {
      inGroup = true;
      break;
    }
  }

  return inGroup;
}

export function userHasRole(user: User, role: Role) {
  return !!user && user.roles.includes(role);
}

export function userHasAnyRole(user: User, roles: Role[]) {
  const rolesToCheck = [ ...roles, ...ADMIN_GROUP ];
  let matchFound = false;

  rolesToCheck.forEach(role => {
    matchFound = user.roles.includes(role) || matchFound;
  });

  return matchFound;
}
